import { render, staticRenderFns } from "./Uldinfo.vue?vue&type=template&id=7e46e1ea"
import script from "./Uldinfo.vue?vue&type=script&lang=js"
export * from "./Uldinfo.vue?vue&type=script&lang=js"
import style0 from "./Uldinfo.vue?vue&type=style&index=0&id=7e46e1ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports